module.exports = __webpack_public_path__ + "static/media/Ameyologo.fa482afb.png";